// Module
var code = "<div paginated-tabs=\"a in list.stats.assignments\" paginated-tabs-group=\"byAssignment\" shift-size=\"page\" static-position=\"true\">\n    <div class=\"rotated-heading\" title=\"{{a.name}}\">{{ a.name || a._id }}</div>\n</div>\n";
// Exports
module.exports = code;